import { Button } from 'src/shared/components/ui/buttons/button'

import RequestCallButton from './request-call-btn'

interface PublicUserProfileFooterProps {
  onSendInquiry: () => void
  username: string
}

export default function PublicUserProfileFooter({ onSendInquiry, username }: PublicUserProfileFooterProps) {
  return (
    <div className="fixed inset-x-5 bottom-5 z-20 flex justify-center">
      <div className="flex w-full flex-row items-center gap-[12px] rounded-full bg-white px-[11px] py-[10px] shadow-[0_0_30px_0_rgba(27,48,41,0.15)] xs:w-fit xs:gap-[15px] xs:p-[13px]">
        <Button
          variant="default"
          onClick={onSendInquiry}
          className="min-w-[300px]:text-[15px] h-[50px] w-full min-w-[100px] rounded-full bg-[#F8F7F5] p-0 text-[14px] font-semibold text-primary xs:h-[55px] xs:w-[200px] xs:text-[17px]"
        >
          Send inquiry
        </Button>
        <RequestCallButton
          showPhoneIcon={false}
          username={username}
          className="h-[50px] w-full rounded-full border-none px-2 py-0 xs:h-[55px] xs:w-[200px]"
          textClassName="text-[14px] min-w-[300px]:text-[15px] xs:text-[17px] md:text-[17px] font-semibold line-clamp-1 leading-[1.5] break-all"
        />
      </div>
    </div>
  )
}
